import tailwindColors from 'tailwindcss/colors';

export const colors = {
	current: 'currentColor',
	white: '#ffffff',
	transparent: 'transparent',
	teal: tailwindColors.teal,
	violet: tailwindColors.violet,
	orange: tailwindColors.orange,
	yellow: tailwindColors.yellow,
	sky: tailwindColors.sky,
	stone: tailwindColors.stone,
	rose: tailwindColors.rose,
	red: tailwindColors.red,
	pink: tailwindColors.pink,
	amber: tailwindColors.amber,
	green: tailwindColors.green,
	emerald: tailwindColors.emerald,
	blue: {
		50: '#f8fafe',
		100: '#ebf2fb',
		200: '#c6dcf7',
		300: '#71a8e9',
		400: '#407edf',
		500: '#3b6cd5',
		600: '#355dcb',
		700: '#2e4a9f',
		800: '#2a407e',
		900: '#1e294d',
		950: '#11182c'
	},
	gray: {
		0: '#ffffff',
		50: '#fafafa',
		75: '#f0f0f0',
		100: '#f7f7f7',
		200: '#e7e7e7',
		300: '#d5d5d5',
		400: '#b1b1b1',
		500: '#909090',
		600: '#6d6d6d',
		700: '#464646',
		800: '#2e2e2e',
		900: '#222222',
		950: '#171717'
	},
	purple: {
		700: '#8E44AD'
	},
	beige: {
		500: '#F6F5F1'
	}
};

export const config = {
	theme: {
		fontFamily: {
			silka: ['Silka'],
			garamond: ['EB Garamond'],
			supreme: ['Supreme Variable']
		},
		// Tailwind's default screens, written out: this config is also imported at
		// runtime (icon colours, breakpoint media queries), and importing
		// `tailwindcss/defaultTheme` for these five values shipped the whole default
		// theme (~23 KiB) to every page.
		screens: {
			xxs: '380px',
			xs: '480px',
			sm: '40rem',
			md: '48rem',
			lg: '64rem',
			xl: '80rem',
			'2xl': '96rem'
		},
		colors,
		extend: {
			containers: {
				xxs: '380px',
				xs: '480px',
				sm: '640px',
				md: '768px',
				lg: '1024px',
				xl: '1280px',
				'2xl': '1536px'
			},
			keyframes: {
				heart: {
					'0%, 100%': { transform: 'scale(1)' },
					'60%': { transform: 'scale(1.1)' }
				},
				iconJump: {
					'0%, 20%, 50%, 80%, 100%': { transform: 'translateY(0)' },
					'40%': { transform: 'translateY(-8px)' },
					'60%': { transform: 'translateY(-4px)' }
				}
			},
			animation: {
				heart: 'heart 1s infinite',
				// One-shot jump shared by the cart and wishlist nav icons when
				// an item is added. Duration matches CART_ANIMATION_DURATION (1s).
				'icon-jump': 'iconJump 1s both'
			}
		}
	}
};
